import axios from 'utils/axios';

const useRestartTour = () => {
    
    const restartTour = async () => {

        try { 
            const response = await axios.put(`berryAPI/user/toggleOnboarding`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json',},
                show_guided_onboarding: true,
            });

            if (response.status != 200){
                throw new Error('Failed to restart guided onboarding tour');
            }
            return true;

        } catch (err){
            console.error(err);
            return false;
        }

    }


    const endTour = async () => {

        try {
            const response = await axios.put(`berryAPI/user/toggleOnboarding`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json',},
                show_guided_onboarding: false,
            });

            if (!(response.status = 200)){
                throw new Error('Failed to end guided onboarding tour');
            }
            return true;
            
        } catch (err){
            console.error(err);
            return false;
        }
    }

    return {restartTour, endTour};
};

export default useRestartTour;